import React, {useState} from 'react';
import PropTypes from 'prop-types';
import css from './InputText.module.scss';
import EyeOpen from '../../Icons/EyeOpen';
import EyeOff from '../../Icons/EyeOff';
import LabelHint from '../LabelHint/LabelHint';

const InputText = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  type = 'text',
  required = false,
  disabled = false,
  autoComplete = true,
  className = '',
  name,
  icon,
  autoFocus = false,
  onKeyDown,
  size,
  maxLength,
  revealable = false,
  onRevealToggle,
  hint,
}) => {
  const [isRevealed, setIsRevealed] = useState(false);

  const resolveInputType = () => {
    if (!revealable) {
      return type;
    }
    return isRevealed ? 'text' : 'password';
  };

  const handleRevealToggle = () => {
    const nextIsRevealed = !isRevealed;
    setIsRevealed(nextIsRevealed);
    if (onRevealToggle) {
      onRevealToggle(nextIsRevealed);
    }
  };

  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <div className={`${css.inputContainer} ${className}`}>
      {label && (
        <label className={css.label}>
          {label}
          {required && <span className={css.required}>*</span>}
          {hint && <LabelHint hint={hint} />}
        </label>
      )}
      <div className={css.inputWrapper}>
        {icon && <div className={css.iconContainer}>{icon}</div>}
        <input
          type={resolveInputType()}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          name={name}
          autoFocus={autoFocus}
          autoComplete={revealable ? 'new-password' : (autoComplete ? 'on' : 'off')}
          onKeyDown={onKeyDown}
          maxLength={maxLength}
          className={`${css.input} ${error ? css.error : ''} ${icon ? css.hasIcon : ''} ${revealable ? css.hasRevealButton : ''} ${size === 'small' ? css.small : ''}`}
          data-error={!!error}
        />
        {revealable && (
          <button
            type="button"
            className={css.revealButton}
            onClick={handleRevealToggle}
            aria-pressed={isRevealed}
            aria-label={label ? `Show ${label}` : 'Show value'}
          >
            {isRevealed ? <EyeOff/> : <EyeOpen/>}
          </button>
        )}
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  );
};

InputText.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func,
  size: PropTypes.oneOf(['small']),
  maxLength: PropTypes.number,
  revealable: PropTypes.bool,
  onRevealToggle: PropTypes.func,
  hint: PropTypes.node,
};

export default InputText;
